function getCookie(name: string) {
    let matches = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : '';
}

export const validateSessionByCookie = () => {
    console.log("============ VALIDATE COOKIE SESSION ======")
    return getCookie("skyUser") || getCookie("skyToken") || getCookie("userProfile") ? true : false
};
